module.exports = __webpack_public_path__ + "static/media/humpback-anglerfish.64ce9033.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/humpback-anglerfish.png
// module id = 318
// module chunks = 0